import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../../../common/Loader";
import FormContainer from "../FormContainer/FormContainer";
import useProductUpdateForm from "../hooks/useProductUpdateForm";
import InputsBlock from "../Layout/InputsBlock";
import AccidentInputs from "./Accident/AccidentInputs";
import AccidentInputs2 from "./Accident2/AccidentInputs2";
import BuildingInputs from "./Building/BuildingInputs";
import ConstructionInputs from "./Construction/ConstructionInputs";
import FundsInputs from "./Funds/FundsInputs";
import GlobalInfosInputs from "./GlobalInfos/GlobalInfosInputs";
import HeadOfficeInfosInputs from "./headOfficeInfos/HeadOfficeInfosInputs";
import RisksInputs from "./Risks/RisksInputs";
import StockageInputs from "./Stockage/StockageInputs";
import useFormState from "./useFormState";

const MRPForm = ({ clientId }) => {
  const { inputsConfig, apiData, formData, actions, errors, mrpForm } =
    useFormState();
  const history = useHistory();

  const { blocksWithError } = useProductUpdateForm({ errors, formData });

  useEffect(() => {
    if (mrpForm.isSaved && Object.keys(errors).length === 0) {
      history.push(`/forms/${clientId}`);
    }
  }, [mrpForm.isSaved]);

  return Object.values(inputsConfig).length > 0 &&
    apiData &&
    mrpForm.isLoaded ? (
    <FormContainer onSubmit={actions.saveForm} isSaving={mrpForm.isSaving}>
      <InputsBlock
        title="Informations de l'entreprise"
        forceOpen={blocksWithError.includes("headOfficeInfosInputs")}
      >
        <HeadOfficeInfosInputs />
      </InputsBlock>
      <InputsBlock
        title="Informations de l'établissement"
        forceOpen={blocksWithError.includes("globalInfosInputs")}
      >
        <GlobalInfosInputs />
      </InputsBlock>
      <InputsBlock
        title="Locaux"
        forceOpen={blocksWithError.includes("constructionInputs")}
      >
        <ConstructionInputs />
      </InputsBlock>
      <InputsBlock
        title="Valeurs des biens"
        forceOpen={blocksWithError.includes("stockageInputs")}
      >
        <StockageInputs />
      </InputsBlock>
      <InputsBlock
        title="Situation"
        forceOpen={blocksWithError.includes("fundsInputs")}
      >
        <FundsInputs />
      </InputsBlock>
      <InputsBlock
        title="Environnement du site"
        forceOpen={blocksWithError.includes("buildingInputs")}
      >
        <BuildingInputs />
      </InputsBlock>
      <InputsBlock
        title="Antécédents"
        forceOpen={blocksWithError.includes("risksInputs")}
      >
        <RisksInputs />
      </InputsBlock>
      <InputsBlock
        title="Garanties 1/2"
        forceOpen={blocksWithError.includes("accident1Inputs")}
      >
        <AccidentInputs />
      </InputsBlock>
      <InputsBlock
        title="Garanties 2/2"
        forceOpen={blocksWithError.includes("accident2Inputs")}
      >
        <AccidentInputs2 />
      </InputsBlock>
    </FormContainer>
  ) : (
    <Loader />
  );
};

export default MRPForm;
